import React from 'react';
import TiposEstrutura from '../components/TiposEstrutura';
import Footer from '../components/Footer';

const HERO_IMAGE_URL = '/index/image1.avif';
const TESTIMONIALS_IMAGE_URL = '/index/image2.avif';
const PRODUCTS_IMAGE_URL = '/index/image3.avif';
const PORTFOLIO_IMAGE_URL = '/index/image8.avif';

function HomePage() {
  return (
    <div>
      <div className="hero">
        <img
          src={HERO_IMAGE_URL}
          alt="MSA Porta Paletes - banner principal"
          className="hero__image"
        />
        <img
          src={TESTIMONIALS_IMAGE_URL}
          alt="MSA Porta Paletes - depoimentos de clientes"
          className="hero__image"
        />
        <div className="accent-line" />
        <img
          src={PRODUCTS_IMAGE_URL}
          alt="MSA Porta Paletes - produtos"
          className="hero__image"
        />
      </div>
      <TiposEstrutura />
      <div className="hero">
        <img
          src={PORTFOLIO_IMAGE_URL}
          alt="MSA Porta Paletes - portf&#243;lio"
          className="hero__image"
        />
      </div>
      <Footer />
    </div>
  );
}

export default HomePage;
